import React from "react";
import { Card, Typography, theme } from "antd";
import type { CardProps } from "antd";
const { Title } = Typography;

type CustomCardProps = CardProps & {
    title?: React.ReactNode;
    titleLevel?: 2 | 3 | 4 | 5; // Flexibility for Title level
    titleColor?: string; // Allow overriding color if needed
};

const CustomCard: React.FC<CustomCardProps> = ({
                                                   title,
                                                   titleLevel = 5,
                                                   titleColor,
                                                   style,
                                                   ...props
                                               }) => {
    const { token } = theme.useToken();
    // If the title is a string, wrap in custom-styled Title:
    const renderedTitle = typeof title === "string" ? (
        <Title
            level={titleLevel}
            style={{
                color: titleColor || token.colorPrimary,
                marginBottom: 0,
                marginTop: 2,
            }}
        >
            {title}
        </Title>
    ) : (
        title
    );

    return (
        <Card
            title={renderedTitle}
            style={{
                borderRadius: 14,
                background: token.colorBgElevated,
                marginBottom: 24,
                boxShadow: token.boxShadow,
                borderTop: `2px solid ${token.colorPrimaryBorder}`,
                overflow: "hidden",
                ...style,
            }}
            {...props}
        />
    );
};

export default CustomCard;
